/* eslint-disable  @typescript-eslint/no-explicit-any */
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { filterOptions } from "./lead-filter/lead-filter.constant";
import _ from "lodash";
import "./lead-qualification-lead-list.scss";
import { getLeads } from "../../api/lead";
import { useLogin } from "../../common/hooks/useUser";
import { AlertComponent, BreadcrumbComponent, MUITable, PaginationComponent } from "../../common/components";
import LeadFilter from "./lead-filter/lead-filter";
import LeadsStatus from "./lead-qualification-leads-status";
import LeadFilterOptions from "./lead-filter/lead-filter-options";
import LeadQualificationDuplicateLead from "./lead-qualification-duplicate-lead/lead-qualification-duplicate-lead";
import LeadQualificationMergeLeads from "./lead-qualification-merge-lead/lead-qualification-merge-lead";
import { breadcrumbLink, getListingViewBreadcrumbLink } from "./lead-qualification-lead-list.constant";
import LeadView from "../leads/lead-view/lead-view";
import { useSetLoading } from "../../common/hooks/appearance";


interface SortOption {
  sortDirection: string | null;
  sortBy: string | null;
}

const LeadQualificationLeadList: React.FC = (props: any) => {

  const [crumbMappingOption, setCrumbMappingOption] =
    useState<any>(breadcrumbLink);

  const [isOpenFilter, setIsOpenFilter] = useState<boolean>(false);
  const [selectedLeadsFilter, setSelectedLeadsFilters] = useState<number[]>([]);
  const [selectedLeadsFilterOptions, setSelectedLeadsFilterOptions] =
    useState<any[]>(filterOptions);
  const [loading, setLoading] = useState<boolean>(false);
  const [totalRecords, setTotalRecords] = useState<number>(0); // Set an initial value for testing
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize] = useState<number>(15);
  const [data, setData] = useState<any[]>([]);
  const [sortOption, setSortOption] = useState<SortOption>({
    sortDirection: null,
    sortBy: null,
  });
  const [alertMessage, setAlertMessage] = useState<string | null>(null);
  const [alertType, setAlertType] = useState<
    "error" | "success" | "info" | "warning"
  >("info");
  const [alertOpen, setAlertOpen] = useState<boolean>(false);
  const [activeFilters, setActiveFilters] = useState<any>({});
  const [searchText, setSearchText] = useState<string>("");
  const [isResetSearch, setIsResetSearch] = useState(false);
  const searchRef = useRef<{ clear: () => void }>(null);
  const [viewOpen, setViewOpen] = useState<boolean>(false);
  const [selectedLeadId, setSelectedLeadId] = useState<any>(null);
  const [selectedLeadsFilterCount, setSelectedLeadsFiltersCount] = useState<any>(null);
  // const [selectedLeadName, setSelectedLeadName] = useState<string>("");
  const [isShowFindDuplicates, setIsShowFindDuplicates] = useState<boolean>(false);
  const [isLeadQualificationMergeLeads, setIsLeadQualificationMergeLeads] = useState<boolean>(false);
  // const [createLeadCaptureInitialValues, setCreateLeadCaptureInitialValues] = useState<any>(null);
  // const [createLeadInitialValues, setCreateLeadInitialValues] = useState<any>(null);
  const isSearchTriggered = useRef(false);

  const handleSearch = useCallback(
    _.debounce((text: string) => {
      isSearchTriggered.current = true;
      setCurrentPage(1)
      setSearchText(text);
      if (text === "") {
        setIsResetSearch(true);
        setTimeout(() => setIsResetSearch(false), 100);
      }
    }, 500),
    []
  );

  const resetSearch = () => {
    setSearchText("");
    if (searchRef.current) {
      searchRef.current.clear();
    }
    handleSearch("");
  };

  const userDetails = useLogin();

  const leadOwner =
    userDetails?.userDetails?.firstName +
    " " +
    userDetails?.userDetails?.lastName;

  const fetchLeads = async (page = 1, search: string = "", filters: any = {}) => {
    setLoading(true);
    try {
      const offset = (page - 1) * pageSize;
      let params: any = {
        limit: pageSize,
        offset: offset,
        unqualifiedLeads: true
      };
      if (sortOption?.sortBy) {
        params = { ...params, ...sortOption };
      }
      if (search) {
        params.searchText = search;
      }
      if (filters?.annualRevenue?.min) {
        params.leadValueMin = filters.annualRevenue.min;
      }
      if (filters?.annualRevenue?.max) {
        params.leadValueMax = filters.annualRevenue.max;
      }
      if (filters?.email) {
        params.email = filters.email;
      }
      if (filters?.city) {
        params.city = filters.city;
      }
      if (filters?.country) {
        params.country = filters.country;
      }
      if (filters?.fax) {
        params.fax = filters.fax;
      }
      if (filters?.firstName) {
        params.firstName = filters.firstName;
      }
      if (filters?.lastName) {
        params.lastName = filters.lastName;
      }
      if (filters?.company) {
        params.company = filters.company;
      }
      if (filters?.industry) {
        params.industry = filters.industry;
      }
      if (filters?.confidenceScore) {
        params.confidenceScore = filters.confidenceScore;
      }
      if (filters?.leadStatus) {
        params.leadStatus = filters.leadStatus;
      }
      if (filters?.createdTimeStart && filters.createdTimeEnd) {
        // if (filters.createdTimeStart.isSame(filters.createdTimeEnd)) {
          params.createdTimeStart = filters.createdTimeStart.startOf('day');
          params.createdTimeEnd = filters.createdTimeEnd.endOf('day');
        // } else {
        //   params.createdTimeStart = filters.createdTimeStart;
        //   params.createdTimeEnd = filters.createdTimeEnd
        // }
      }
      if (filters?.lastActivityTimeStart && filters.lastActivityTimeEnd) {
        // if (filters.lastActivityTimeStart.isSame(filters.lastActivityTimeEnd)) {
          params.lastActivityStart = filters.lastActivityTimeStart.startOf('day');
          params.lastActivityEnd = filters.lastActivityTimeEnd.endOf('day');
        // } else {
        //   params.lastActivityStart = filters.lastActivityTimeStart;
        //   params.lastActivityEnd = filters.lastActivityTimeEnd
        // }
      }
      if (filters?.createdBy?.length > 0) {
        params.createdBy = filters.createdBy.map(Number);
      }
      if (filters?.leadOwner?.length > 0) {
        params.leadOwner = filters.leadOwner.map(Number);
      }
      if (filters?.assignedPartner?.length > 0) {
        params.assignedPartner = filters.assignedPartner.map(Number);
      }
      const response = await getLeads(params);
      setData(response.data.data.leads);
      setTotalRecords(response.data.data.totalRecords);
      setTimeout(() => setLoading(false), 1000);
    } catch (error: any) {
      setAlertMessage(error?.response?.data?.message || "Failed to fetch campaigns");
      setAlertType("error");
      setAlertOpen(true);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!viewOpen && !isShowFindDuplicates && !isLeadQualificationMergeLeads) {
      const pageToUse = isSearchTriggered.current ? 1 : currentPage;
      fetchLeads(pageToUse, searchText, activeFilters);
      isSearchTriggered.current = false;
    }
  }, [currentPage, searchText, sortOption, activeFilters, isShowFindDuplicates, isLeadQualificationMergeLeads]);

  useEffect(() => {
    if (!viewOpen) {
      setCurrentPage(1);
      fetchLeads(1, searchText, activeFilters);
    }
  }, [ viewOpen]);

  useEffect(() => {
    if(selectedLeadsFilter?.length === 0) {
    setSelectedLeadsFiltersCount(0);
    setActiveFilters({});
    }
  }, [selectedLeadsFilter]);

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setCurrentPage(value);
  };

  const headers = [
    { key: "leadName", label: "Lead Name", isSortable: true },
    { key: "email", label: "Email", isSortable: true },
    { key: "phone", label: "Phone Number", isSortable: true },
    { key: "leadSource", label: "Lead Source", isSortable: true },
    { key: "leadOwner", label: "Lead Owner", isSortable: true },
    { key: "leadCreatedBy", label: "Created By", isSortable: true },
    { key: "leadStatus", label: "Lead Status", isSortable: true },
  ];

  const mapColumnNameToField = (columnName: string): string => {
    const mapping: Record<string, string> = {
      leadName: "first_name",
      email: "primary_email_address",
      phone: "primary_phone_number",
      leadSource: "lead_source",
      leadOwner: "lead_owner",
      leadStatus: "lead_status",
      leadCreatedBy: "created_by",
    };

    return mapping[columnName] || columnName;
  };

  const handleSort = (column: string, sortType: string) => {
    let sortValues: SortOption = { sortBy: null, sortDirection: null };
    if (sortType !== "Unsort") {
      const mappedField = mapColumnNameToField(column);
      sortValues = { sortBy: mappedField, sortDirection: sortType };
    }
    setCurrentPage(1);
    setSortOption(sortValues);
  };

  const fetchFullName = (item: any) => {
    const firstName = item?.first_name?.trim();
    const lastName = item?.last_name?.trim();
    const fullName =
      firstName && lastName
        ? `${firstName} ${lastName}`
        : firstName
          ? firstName
          : lastName
            ? lastName
            : "-";
    return fullName;
  }

  const formattedData = useMemo(() => {
    if (Array.isArray(data)) {
      return data.map((item) => {
        const firstName = item.first_name?.trim();
        const lastName = item.last_name?.trim();
        const middleName = item?.middle_name ? item?.middle_name?.trim() : "";
        const fullName =
          firstName && lastName
            ? `${firstName ? `${firstName} `:""}${middleName ? `${middleName} `:""}${lastName}`
            : firstName || middleName || lastName || "-";

        const leadName = fullName;
        const leadOwnerName = fetchFullName(item?.owner)
        const createdBy = fetchFullName(item?.createdBy)
        return {
          id: item.id,
          leadName: leadName,
          email: item.primary_email_address || "-",
          phone: item.primary_phone_number || "-",
          leadSource: item.lead_source || "-",
          leadOwner: leadOwnerName,
          leadStatus: item.lead_status || "-",
          leadCreatedBy: createdBy
        };
      });
    }
    return [];
  }, [data, leadOwner]);

  const handleViewClick = async (leadId: number, leadName: string) => {
    setSelectedLeadId(leadId);
    // setSelectedLeadName(leadName);
    setCrumbMappingOption( getListingViewBreadcrumbLink(setViewOpen, setSelectedLeadId, setCrumbMappingOption, leadName));

    setViewOpen(true);
  };

  const handleLeadNameUpdate = (newName: string) => {
    // setSelectedLeadName(newName);
    setCrumbMappingOption((prev: any) => {
      const updated = [...prev];
      updated[2] = { ...updated[2], label: newName };
      return updated;
    });
  };

  const showLoading = useMemo(() => loading, [loading]);
  useSetLoading(showLoading);

  return (
    <>
      {isShowFindDuplicates ? (
        <LeadQualificationDuplicateLead
            setIsShowFindDuplicates={setIsShowFindDuplicates}
            setAlertMessage={setAlertMessage}
            setAlertType={setAlertType}
            setAlertOpen={setAlertOpen}
            setLoading={setLoading}
            setIsLeadQualificationMergeLeads={setIsLeadQualificationMergeLeads}
            // fetchLeadCaptureForms={fetchLeadCaptureForms}
        />
      ): isLeadQualificationMergeLeads ? 
          <LeadQualificationMergeLeads
            setAlertMessage={setAlertMessage}
            setAlertType={setAlertType}
            setAlertOpen={setAlertOpen}
            setLoading={setLoading}
            isLeadQualificationMergeLeads={isLeadQualificationMergeLeads}
            setIsLeadQualificationMergeLeads={setIsLeadQualificationMergeLeads}
          />
       :
      <div
        className="lead-qualification-form-leadlist-wrapper"
        style={{ display: isShowFindDuplicates ? "none" : "block" }}
      >
        <div className="breadcrumb-wrapper">
          <BreadcrumbComponent
            breadcrumbLink={crumbMappingOption}
            showBackArrow={false}
            handleBackArrowClick={() => {
            }} />
        </div>

        <div style={{ display: !viewOpen ? "block" : "none" }}>
          <LeadFilter
            isOpenFilter={isOpenFilter}
            setIsOpenFilter={setIsOpenFilter}
            selectedLeadsFilter={selectedLeadsFilter}
            selectedLeadsFilterCount={selectedLeadsFilterCount}
            onSearch={handleSearch}
            searchRef={searchRef}
            isResetSearch={isResetSearch}
            resetSearch={resetSearch}
            handleClickCreateNewForm={() => {
              setIsShowFindDuplicates(true);
            }}
          />

          <div className="lead-captured-form-lead-list-table-filter">
            <div
              className="lead-captured-form-lead-list-table"
              style={isOpenFilter ? { width: "80%" } : {}}
            >
              <MUITable
                headers={headers}
                data={formattedData.map((item) => ({
                  key: item.id,
                  leadName: item.leadName,
                  email: item.email,
                  phone: item.phone,
                  leadSource: item.leadSource,
                  leadOwner: item.leadOwner,
                  leadCreatedBy: item.leadCreatedBy,
                  leadStatus: <LeadsStatus status={item.leadStatus} />,
                }))}
                onSort={handleSort}
                noResultsTxt={" No leads found"}
                onRowClick={(rowData: any) => handleViewClick(rowData.key, rowData.leadName)}
              />
            </div>

            <div
              style={{ display: isOpenFilter ? "block" : "none" }}
              className="lead-captured-form-lead-list-filter"
            >
              <LeadFilterOptions
                isOpenFilter={isOpenFilter}
                setIsOpenFilter={setIsOpenFilter}
                selectedLeadsFilter={selectedLeadsFilter}
                setSelectedLeadsFilters={setSelectedLeadsFilters}
                selectedLeadsFilterOptions={selectedLeadsFilterOptions}
                setAlertMessage={setAlertMessage}
                setAlertType={setAlertType}
                setAlertOpen={setAlertOpen}
                setSelectedLeadsFilterOptions={setSelectedLeadsFilterOptions}
                setSelectedLeadsFiltersCount={setSelectedLeadsFiltersCount}
                onApplyFilters={(filters: any) => {
                  setActiveFilters(filters);
                  setSelectedLeadsFiltersCount(selectedLeadsFilter?.length);
                }}
              />
            </div>
          {totalRecords && totalRecords > 0 ? (
            <div className="leads-pagination-container qualification-leads-pagination">
                  <PaginationComponent
                    totalRecords={totalRecords}
                    pageSize={pageSize}
                    currentPage={currentPage}
                    onPageChange={handlePageChange}
                  />
            </div>
            ) : (
              <></>
            )}                    
          </div>
        </div>

        {viewOpen && (
          <LeadView
            setLoading={setLoading}
            selectedLeadId={selectedLeadId}
            onLeadNameUpdate={handleLeadNameUpdate}
          />
        )}
      </div>}

      <AlertComponent
        message={alertMessage}
        type={alertType ?? "info"}
        open={alertOpen}
        onClose={() => setAlertOpen(false)}
      />
    </>
  );
};

export default LeadQualificationLeadList;